<template>
  <footer>
    <div class="hlp-btn">
      <p>A Product of <span>Mamabots</span>.</p>
      <div class="btn-container">
        <router-link
          v-if="showButtons"
          to=""
          @click.prevent="logout"
          class="logout-btn"
        >
          <i class="fa-solid fa-arrow-right-to-bracket"></i> Logout
        </router-link>
<router-link v-if="showButtons" to="/customer-support" class="help-btn">
          <i class="fa-solid fa-circle-info"></i> Help
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { AuthService } from "@/services/auth.service";

export default {
  name: "FooterView",
  props: {
    showButtons: {
      type: Boolean,
      default: false,
    },
    alignButtonsRight: {
      type: Boolean,
      default: true, // Default: Buttons appear on the right
    },
  },
  methods: {
    async logout() {
      try {
        await AuthService.makeLogout();

        // this.$store.commit("toast/NEW", {
        //   type: "success",
        //   message: "Logged Out Successfully!",
        // });

        setTimeout(() => {
          this.$router.push({ name: "KioskLogin" });
        }, 1000);
      } catch (err) {
        console.error("Logout Error:", err);

        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Logout failed. Please try again.",
        });

        // Force local logout (fallback)
        this.$router.push({ name: "KioskLogin" });
      }
    },
  },
};
</script>

<style>
.hlp-btn {
  padding-top: 0;
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
  left: 0;
  right: 0;
}

.hlp-btn p {
  font-size: 20px;
  color: #181818;
  font-weight: 500;
}

.hlp-btn p span {
  color: #fe001a;
}

.btn-container {
  display: flex;
  justify-content: space-between; /* Moves Help left and Logout right */
  align-items: center;
  width: 100%;
  padding: 0 30px;
  position: absolute;
  bottom: 15px;
}

.hlp-btn a {
  background-color: #fff;
  text-decoration: none;
  padding: 0px 30px 0px 0px;
  border-radius: 5px;
  color: #606060;
  font-size: 22px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.hlp-btn a i {
  background-color: #007af8;
  color: #fff;
  padding: 21px 22px !important;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-right: 25px;
}

/* If both buttons should be on the right */
.hlp-btn.right-align .btn-container {
  justify-content: flex-end;
  gap: 15px;
}
</style>
